import { action } from '@ember/object';
import Component from '@glimmer/component';

import FormCheckboxSwitchComponent from 'webapp/components/form/checkbox-switch';

import type Block from 'webapp/models-custom/block';
import type BlockSetup from 'webapp/models-custom/block-setup';
import type VisualizationNumber from 'webapp/models-custom/visualization/number';

interface Args {
	blockM: Block;
}

export default class BlockSettingsSmallChartComponent extends Component<Args> {
	get block(): Block {
		return this.args.blockM;
	}

	get blockSetup(): BlockSetup {
		return this.block.blockSetup;
	}

	get blockVisualization(): VisualizationNumber {
		return this.block.blockSetup.visualization as VisualizationNumber;
	}

	get selected(): boolean {
		return !!this.blockVisualization.hasSmallChart;
	}

	@action
	changeSelected(selected: boolean): void {
		this.blockVisualization.hasSmallChart = selected;
	}
	<template>
		<div class="row row--toggle">
			<FormCheckboxSwitchComponent
				@name="smallChart"
				@selected={{this.selected}}
				@onChange={{this.changeSelected}}
			/>
			<label>Show small chart</label>
		</div>
	</template>
}
